import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    components: {
        MuiCardActions: {
            styleOverrides: {
                root: {
                    justifyContent: 'flex-end',
                },
            },
        },
        MuiButton: {
            defaultProps: {
                color: 'secondary',
            },
        },
        MuiTextField: {
            defaultProps: {
                color: 'secondary',
            },
        },
        MuiTabs: {
            defaultProps: {
                textColor: 'black',
                indicatorColor: 'secondary',
            },
        },
        MuiCheckbox: {
            defaultProps: {
                color: 'secondary',
            },
        },
        MuiSwitch: {
            defaultProps: {
                color: 'secondary',
            },
        },
        MuiRadio: {
            defaultProps: {
                color: 'secondary',
            },
        },
        MuiDatePicker: {
            defaultProps: {
                textColor: 'secondary',
            },
        },
        MuiSelect: {
            defaultProps: {
                color: 'secondary',
            },
        },
    },
    palette: {
        primary: {
            main: '#39E991',
        },
        secondary: {
            main: '#1976d2',
        },
        background: {
            light: '#363636',
            dark: '#262626',
        },
        action: {
            hover: '#d5d5d5',
        },
    },
    typography: {
        header: {
            fontSize: '1.3rem',
        },
        subHeader: {
            fontSize: '0.8rem',
            color: '#616161',
        },
    },
});
